
import React from 'react';

import { AsiteDocumentsSyncClientLogDto } from '../../../../../swagger';
import api from '../../../../../libs/api';
import { useQuery } from 'react-query';
import { configQueryReactCodetable } from '../../../../../Hooks';
import { FastDraftRelaticsTempLogDto } from '../../../../../codegen/Swagger';


const fetchDocumentFindingStatus = async (id: number) => await api.get(`/api/v2/FastDraftRelaticsSync/GetTempSyncClientLogs?clientLogId=${id}`, { safe: true });

const useDocumentFindingStatusQuery = (setData: React.Dispatch<React.SetStateAction<FastDraftRelaticsTempLogDto[]>>, id: number) => {
    const documentFindingStatus = useQuery('fast-draft-relatics-temp-log', () => fetchDocumentFindingStatus(id), {
        ...configQueryReactCodetable,
        onSuccess: (result: FastDraftRelaticsTempLogDto[]) => {
            setData(result)
        }
    });

    return documentFindingStatus;
};


const useRelaticsRealTimeLogDialog = (data: FastDraftRelaticsTempLogDto[], setData: React.Dispatch<React.SetStateAction<FastDraftRelaticsTempLogDto[]>>, dataItem: any) => {

    const query = useDocumentFindingStatusQuery(setData, dataItem.id);

    return { query };

};


export default useRelaticsRealTimeLogDialog;